import { ErrorOnLogoutException } from '@/domain/login/exceptions';

export const logoutUserExecute = async (platform, logoutUser) => {
  const {
    data: dataUser,
    status: statusLogout,
    responseCode,
  } = await logoutUser(platform);

  if (statusLogout === 200 && responseCode === '00') {
    localStorage.removeItem('token');
    return { responseCode, dataUser };
  } else {
    throw new ErrorOnLogoutException({ errorCode: responseCode });
  }
};
